// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3QytO","header":"Messages_header__2rWB3"};